/**
 * Job-logs polling hook (T027). Polls in lockstep with the job: reads the job
 * status from the `['job', id]` cache so logs stop exactly when the job goes
 * terminal — no independent terminal logic (W9 consistency).
 */
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { getJobLogs } from '../lib/endpoints/jobs'
import { qk } from '../lib/queryKeys'
import { isActive } from '../lib/jobStatus'
import type { Job } from '../lib/schemas'

export function useJobLogs(id: string, limit?: number) {
  const qc = useQueryClient()
  return useQuery({
    queryKey: qk.jobLogs(id),
    queryFn: () => getJobLogs(id, limit),
    enabled: !!id,
    refetchInterval: () =>
      isActive(qc.getQueryData<Job>(qk.job(id))) ? 3000 : false,
    retry: 1,
    staleTime: 2500,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
  })
}
